import { render, staticRenderFns } from "./UpdatedProfile.vue?vue&type=template&id=6963d60f&scoped=true&"
import script from "./UpdatedProfile.vue?vue&type=script&lang=js&"
export * from "./UpdatedProfile.vue?vue&type=script&lang=js&"
import style0 from "./UpdatedProfile.vue?vue&type=style&index=0&id=6963d60f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963d60f",
  null
  
)

export default component.exports